import Controller from "csi/action/Controller";
import declare from "dojo/_base/declare";
import FormData from "csi/action/FormData";
import Writer from "csi/xml/Writer";

const EnableLockAttributesController = declare(Controller, {

	/**
	 * @override
     * Return form data for view. In this case, turn off selections and make editable
     */
	getFormData(): FormData {
		let fd = this.m_formData;
		if (!fd) {
			fd = this.inherited<FormData>(arguments);
			fd.m_bAllowSelections = false;
			fd.m_bEditable = true;
		}

		return fd;
	},

	/**
	 * @override
	 * Enable save button if writer has changed; protect against writer being null when controller is finishing up
	 * @param {Object} params
	 */
	onCreatePopupParams(params: { canEnableButton: (_button: any, idAction: any) => boolean; writerForActions: Writer }) {
		const { m_writer } = this;
		params.canEnableButton = (_button: any, idAction: string): boolean => {
			return m_writer && (m_writer.isChanged() || (idAction !== "Save"));
		};
		params.writerForActions = m_writer;
	},

	/**
	 * @override
	 * Refresh cache if cancelled
	 */
	postProcessCancel() {
		this.widget.refreshData();
	 },
});

export = EnableLockAttributesController;